// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1xHZD","choiceBoxes":"toolbarselects_choiceBoxes__pGdRS","simpleField":"toolbarselects_simpleField__1u0NM"};